import { render, staticRenderFns } from "./TemplateManager.vue?vue&type=template&id=044a5322&scoped=true&"
import script from "./TemplateManager.vue?vue&type=script&lang=js&"
export * from "./TemplateManager.vue?vue&type=script&lang=js&"
import style0 from "./TemplateManager.vue?vue&type=style&index=0&id=044a5322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a5322",
  null
  
)

export default component.exports